module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"ctrl-psel-item\">\n    ")
    ; var path = [], label = [];
    ; __append("\n    ")
    ;  _.forEach(item, (oneItem) =>{
    ; __append("\n        ")
    ;  label.push(_.get(oneItem, control.titleKey)); 
    ; __append("\n        ")
    ;  path.push(oneItem.id);
    ; __append("\n    ")
    ;  }) 
    ; __append("\n    <span>\n        ")
    ; __append(escapeFn(label.join('/')))
    ; __append("\n    </span>\n    ")
    ;  if (control.multiple && !viewOnly) { 
    ; __append("\n        <a href=\"javascript:void(0)\" class=\"remove\" data-path=\"")
    ; __append(escapeFn( path.join('/') ))
    ; __append("\"><icon class=\"icon-16 icon-trash-o icon-16\"/></a>\n    ")
    ;  } 
    ; __append("\n</div>")
  }
  return __output.join("");

}